import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import WelcomePage from "./pages/WelcomePage";
import EmployeeDetails from "./pages/EmployeeDetails";
import Login from "./pages/LoginPage";
import Unauthorized from "./pages/Unauthorized";

function App() {
  const [user, setUser] = useState(() => {
    const username = sessionStorage.getItem("username");
    const company = sessionStorage.getItem("companyName");
    const email = sessionStorage.getItem("email");
    const address = sessionStorage.getItem("address");
    return username && company ? { username, company } : null;
  });

  const handleLoginSuccess = (username, company) => {
    setUser({ username, company });
    sessionStorage.setItem("username", username);
    sessionStorage.setItem("companyName", company);
  };

  const handleLogout = () => {
    setUser(null);
    sessionStorage.clear();
  };

  return (
    <Router>
      <Routes>
        {/* Public Route */}
        <Route path="/login" element={<Login onLogin={handleLoginSuccess} />} />

        {/* Protected Routes */}
        <Route
          path="/welcome/*"
          element={
            user ? <WelcomePage onLogout={handleLogout} /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/employee/*"
          element={
            user ? <EmployeeDetails onLogout={handleLogout} /> : <Navigate to="/login" replace />
          }
        />
         <Route path="/unauthorized" element={<Unauthorized />} />

        {/* Default Redirect */}
        <Route path="/*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;


// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import WelcomePage from './pages/WelcomePage';
// import EmployeeDetails from './pages/EmployeeDetails';
// import { Navigate } from 'react-router-dom';

// function App() {
//   return (
//     <Router>
//       <Routes>
//         <Route path="/welcome/*" element={<WelcomePage />} />    
//         <Route path="/employee/*" element={<EmployeeDetails />} />
//         <Route path="/*" element={<Navigate to="/welcome" replace />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;
